import { Injectable } from '@angular/core';

declare let _bnmxData: any;
declare let bnmx_tms: any;

@Injectable({
  providedIn: 'root',
})
export class QuickPayMetricsService {
  // constants
  private language = 'ES';

  constructor() {}

  initBnmxData(
    serverInfo: string,
    custType: string,
    productInstrument: string,
  ) {
    try {
      _bnmxData = {
        PgID: 'MX|BNP3|DETALLE_TDC',
        custType: 'MX|BNP3|' + custType,
        prodNameOrig: productInstrument,
        language: this.language,
        server: serverInfo,
      };
      // bnmx_tms.sendMetric();
    } catch (e) {
      console.log(e);
    }
  }

  // cover K1, K2, K3
  sendInterationK123(): void {
    console.log('Did click K1K2K3');
    try {
      bnmx_tms.interactionDetails('Pagar');
    } catch (e) {
      console.log(e);
    }
  }

  // start step 1 KPI 3
  quickPayStart(): void {
    console.log('Did KPI 3');
    try {
      bnmx_tms.quickPayStart();
    } catch (e) {
      console.log(e);
    }
  }

  // some field error KPI 4
  quickPayErrorField(field: string, errorDetail: string): void {
    console.log('Did KPI 4');
    try {
      bnmx_tms.quickPayError(`${field}|${errorDetail}`);
    } catch (e) {
      console.log(e);
    }
  }

  // Error operation KPI 18
  quickPayErrorScreen(step: string, errorDetail: string): void {
    console.log('Did KPI 18');
    try {
      bnmx_tms.quickPayError(`${step}|${errorDetail}`);
    } catch (e) {
      console.log(e);
    }
  }

  // Retry operation
  quickPayRetryInteraction(): void {
    console.log('Did click QuickPay_Error|Salir');
    try {
      bnmx_tms.interactionDetails('QuickPay_Error|Salir');
    } catch (e) {
      console.log(e);
    }
  }

  // Cancel interaction KPI5
  quickPayCancelInteraction(): void {
    console.log('Did click KPI5');
    try {
      bnmx_tms.interactionDetails('Cancelar|QuickPay');
    } catch (e) {
      console.log(e);
    }
  }

  // Cancel interaction KPI 19
  quickPayCancelInteractionSpecific(step: string): void {
    console.log('Did click KPI 19');
    try {
      bnmx_tms.interactionDetails(`${step}|QuickPay|Cerrar`);
    } catch (e) {
      console.log(e);
    }
  }

  // Use a filter dropdown
  quickPayInteractionFilter(): void {
    console.log('Did click KPI 6');
    try {
      bnmx_tms.interactionDetails('Quick_Pay|CuentaRetiro');
    } catch (e) {
      console.log(e);
    }
  }

  // filter dropdown no found
  quickPayInteractionFilterNoFound(): void {
    console.log('Did KPI 7');
    try {
      bnmx_tms.interactionDetails('Quick_Pay|CuentaRetiro|SinResultados');
    } catch (e) {
      console.log(e);
    }
  }

  // start step 2 KPI 3
  quickPayStepConfirm(): void {
    console.log('Did KPI 8');
    try {
      bnmx_tms.quickPayStep2();
    } catch (e) {
      console.log(e);
    }
  }

  // return interaction step 2
  quickPayInteractionReturn(): void {
    console.log('Did KPI 9');
    try {
      bnmx_tms.interactionDetails('Regresar|QuickPay');
    } catch (e) {
      console.log(e);
    }
  }

  // start step 3 KPI 10, 11, 12, 13,16,20
  quickPayStepPay(
    accountWithdrawal: string,
    concep: string,
    schedule: 'Ahora' | 'Programado',
    amount: string,
    typeOperation: string,
  ): void {
    console.log('Did quickPayStep3');
    try {
      bnmx_tms.quickPayStep3(
        `${accountWithdrawal}|${concep}|${schedule}`,
        `${amount}|${typeOperation}`,
      );
    } catch (e) {
      console.log(e);
    }
  }

  // return interaction step 2
  quickPayInteractionPrint(): void {
    console.log('Did click print');
    try {
      bnmx_tms.interactionDetails('Imprimir|QuickPay');
    } catch (e) {
      console.log(e);
    }
  }

  // interaction Listo button
  quickPayInteractionReady(): void {
    console.log('Did click Listo button');
    try {
      bnmx_tms.interactionDetails('Listo|QuickPay');
    } catch (e) {
      console.log(e);
    }
  }

  // some error without accounts KPI17
  quickPayError(): void {
    console.log('Did click KPI17');
    try {
      bnmx_tms.quickPayError('SinCuentas');
    } catch (e) {
      console.log(e);
    }
  }
}
